<template>
    <div>
        <Header class="inline-block">
            <template v-slot:title><span class="text-lg capitalize">Habilidades profesionales</span></template>
        </Header>
        <div class="grid grid-cols-1 gap-4 lg:gap-8 lg:grid-cols-2">
            <div v-for="(skill, index) in data" :key="index" class="box-border relative flex flex-col justify-between w-full bg-opacity-25 border-2 border-background-menu">
                <div class="flex items-center bg-opacity-25 border-b-2 border-background-menu skill__title">
                    <span class="m-3 skill__image">
                        <svg fill="currentColor" viewBox="0 0 20 20" class="w-6 h-6">
                            <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z"></path>
                        </svg>
                    </span>
                    <span class="text-lg font-semibold">{{ skill.name }}</span>
                </div>
                <div class="flex flex-1 p-6 bg-opacity-25 border-b-2 skill__description border-background-menu">
                    {{ skill.description }}
                </div>
                <div class="absolute justify-end p-2 m-2 text-white border border-t-2 border-b-2 border-l-2 border-r-2 rounded-full top-5 score bg-tertiary right-5 border-background-menu">
                    {{ skill.score }}%
                </div>
                <div class="p-3 skill__footer">
                    <div class="flex items-baseline justify-between flex-shrink">
                        <div class="flex flex-wrap flex-1 skill__labels">
                            <span v-for="(tech, index) in skill.technologies" :key="index" v-text="tech" class="px-2 mt-2 ml-3 text-xs rounded-full bg-tertiary text-letter-profile"></span>
                        </div>
                        <span class="flex ml-4 text-xs text-center uppercase">Level: {{ skill.level }}</span>
                    </div>
                    <div class="w-full h-2 my-3 bg-opacity-0 rounded-full skill__footer-bar bg-secondary">
                        <div class="h-full rounded-full bg-tertiary" :style="`width: ${skill.score}%`"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import data from '../data/skills'
import Header from './Header'

export default {
    components: {
        Header
    },
    data() {
        return {
            data: data,
        }
    }
}
</script>
